import axios from 'axios';
import user from './user';

export default {
  state: {
    token: null,
    isLoggedIn: null,
  },
  mutations: {
    LOGIN_SUCCESS(state, response) {
      state.token = response.data.key;
      state.isLoggedIn = true;
    },
    LOGOUT(state) {
      state.isLoggedIn = null;
      state.token = null;
      user.state.user_slug = null;
    },
  },
  actions: {
    UserSignIn({ commit, dispatch, state }, payload) {
      return axios.post('rest-auth/login/', {
        email: payload.email,
        password: payload.password,
      })
        .then((response) => {
          commit('LOGIN_SUCCESS', response);
          // I'd prefer to call the token from the state or a getter,
          // but I can't seem to get it working properly.
          dispatch('user/getUserInfo', response.data.key);
        })
        .catch(
        );
    },
    UserLogout({ commit }) {
      return axios.post('rest-auth/logout/', '')
        .then(
          commit('LOGOUT'),
        )
        .catch(
        );
    },
  },
  getters: {
    token(state) {
      return state.token;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
  },
};
